import { combineReducers } from "redux";
import UserReducer from "./user-reducer";
import AuthReducer from "./auth-reducer";
import CaseReducer from "./case-reducer";
import CaseCountReducer from "./case-count-reducer";
import CompanyReducer from "./company-reducer";
import CaseDetailReducer from "./case-detail-reducer";
import StageReducer from "./stage-reducer";
import StagePermissionReducer from "./stage-permission-reducer";
import SupplyChainReducer from "./supply-chain-reducer";
import QuestionareReducer from "./questionare-reducer";
import RetailerRiskControlReducer from "./retailer-risk-control-reducer";
import DocumentsReducer from "./documents-reducer";
import StatementReducer from "./statement-reducer";
import ScorecardReducer from "./scorecard-reducer";
import CaseCreateReducer from "./case-create-reducer";
import FinancialsReducer from "./financials-reducer";
import CaseNoteReducer from "./case-note-reducer";
import PayProCaseNoteReducer from "./paypro-case-note-reducer";
import UpgradeCaseReducer from "./upgrade-case-reducer";
import SchemesReducer from "./schemes-reducer";
import ToggleHelpReducer from "./toggle-help-reducer";
import MarketDataReducer from "./market-data-reducer";
import RegionReducer from "./region-reducer";
import CaseMetaReducer from "./case-meta-reducer";
import facilityAccountReducer from "./facility-account-reducer";
import decisioningDashboardReducer from "../../modules/decision-dashboard/reducers";
import GstinDetailsReducer from "./gstin-details-reducers";
import BankStatementAnalyserReducer from "./bank-statement-analyser-reducer";
import applicantVerificationReducer from "./applicant-verification-reducer";
import { CompanyLosProfileReducer, InvoiceJobReducer } from "./../../modules/companies/reducers";
// import BucketCaseReducer from "./bucket-case-reducer";
import AccountViewReducer from "./account-view-reducer";
import LendingPartnerReducer from "./../../modules/lenders/reducers";
import BankAccountReducer from "./../../modules/virtual-accounts/reducer";
import cibilDetailsReducer from "./cibil-details-reducer";
import PaymentProgramDetailsReducer from "./payment-program-details-reducer";
import DBOnBoardinReducer from './db-onboarding-reducer';
import OnboardingReducer from "./onboarding-reducer";

export default combineReducers({
    user: UserReducer,
    auth: AuthReducer,
    cases: CaseReducer,
    stages: StageReducer,
    stagePermissions: StagePermissionReducer,
    companies: CompanyReducer,
    caseDetails: CaseDetailReducer,
    bankStatementAnalyser: BankStatementAnalyserReducer,
    caseMeta: CaseMetaReducer,
    caseCount: CaseCountReducer,
    supplyChain: SupplyChainReducer,
    questionare: QuestionareReducer,
    documents: DocumentsReducer,
    statements: StatementReducer,
    scorecard: ScorecardReducer,
    caseCreate: CaseCreateReducer,
    financials: FinancialsReducer,
    caseNotes: CaseNoteReducer,
    upgradedCases: UpgradeCaseReducer,
    schemes: SchemesReducer,
    toggleHelp: ToggleHelpReducer,
    marketData: MarketDataReducer,
    regionData: RegionReducer,
    facilityAccount: facilityAccountReducer,
    companyLosProfiles: CompanyLosProfileReducer,
    // BucketCaseReducer: BucketCaseReducer
    accountViewInfo: AccountViewReducer,
    decisioningDashboard: decisioningDashboardReducer,
    gstinDetails: GstinDetailsReducer,
    applicantVerificationList: applicantVerificationReducer,
    invoiceJobs: InvoiceJobReducer,
    lenders: LendingPartnerReducer,
    bankAccount: BankAccountReducer,
    cibilDetails: cibilDetailsReducer,
    paymentProgramDetails: PaymentProgramDetailsReducer,
    payProCaseNoteReducer: PayProCaseNoteReducer,
    dbOnBoarding: DBOnBoardinReducer,
    onboardingData : OnboardingReducer,
    retailerRiskControlData : RetailerRiskControlReducer,
});
